import { getDomainListPathDayUtil } from '../../../../models/day/utils'
import { getDomainListPathsProfileLogUtil } from '../../../../models/profile-log/utils/get-domain-list-paths'
import { getDomainListPathsWorkoutUtil } from '../../../../modules/workout/model/utils/get-domain-list-paths'
import { DAY_CLASS_NAME } from '../../../day'
import { getDomainListPathsMessageUtil, MESSAGE_CLASS_NAME } from '../../../message'
import { getDomainListPathPlanUtil, PLAN_CLASS_NAME } from '../../../plan'
import { POST_CLASS_NAME } from '../../../post/model/constants'
import { PROFILE_LOG_CLASS_NAME } from '../../../profile-log'
import getClassNameReduxUtil from '../get-class-name'
import getDefaultDomainListPathReduxUtil from '../get-default-domain-list-path'
import { WORKOUT_CLASS_NAME } from '../../../workout'
import { EXERCISE_CLASS_NAME, getDomainListPathExerciseUtil } from '../../../exercise'
import { getDomainListPathPostUtil } from '../../../post'

const CLASS_NAME_TO_FUNCTION = {
  [DAY_CLASS_NAME]: getDomainListPathDayUtil,
  [EXERCISE_CLASS_NAME]: getDomainListPathExerciseUtil,
  [PLAN_CLASS_NAME]: getDomainListPathPlanUtil,
  [WORKOUT_CLASS_NAME]: getDomainListPathsWorkoutUtil,
  [MESSAGE_CLASS_NAME]: getDomainListPathsMessageUtil,
  [PROFILE_LOG_CLASS_NAME]: getDomainListPathsProfileLogUtil,
  [POST_CLASS_NAME]: getDomainListPathPostUtil
}

/**
 * @param props
 * @param props.instance
 * @param props.state
 * @param props.domainListPath
 * @returns {any[]|*[]}
 */
export default function getDomainListPathsReduxUtil (props) {
  const { instance, state, domainListPath } = props
  if (!instance) {
    return []
  }
  const className = getClassNameReduxUtil(instance)
  const fn = CLASS_NAME_TO_FUNCTION[className]

  let domainListPaths = fn
    ? fn(instance, state)
    : []

  if (!domainListPaths) {
    domainListPaths = []
    console.warn('[getDomainListPathsReduxUtil] [empty]: domain list path')
  }

  if (!Array.isArray(domainListPaths)) {
    domainListPaths = [domainListPaths]
  }

  if (domainListPath && !domainListPaths.includes(domainListPath)) {
    domainListPaths.push(domainListPath)
  }

  const defaultDomainList = getDefaultDomainListPathReduxUtil(instance)
  if (defaultDomainList && !domainListPaths.includes(defaultDomainList)) {
    domainListPaths.unshift(getDefaultDomainListPathReduxUtil(instance))
  }

  return domainListPaths
}
